/* eslint-disable camelcase */
import React, { useState, useEffect, useRef } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= module component import section ========= //
import { Modal, ModalBody } from 'reactstrap';
import { IconContext } from 'react-icons';
import { GrFormDown, GrClose } from 'react-icons/gr';
import _ from 'lodash';
import moment from 'moment';
import CurrencyFormat from 'react-currency-format';
// ====== end of module component import section ====== //

// ========= project component import section ========= //
import { emptyImage, getCloudImageUrl } from '../../../utils';
import {
  accessoriesCondition,
  boxCondition,
  boxHandbag,
  dustBag,
  formatRupiah,
  handbagCondition,
  sneakersCondition,
  yellowing,
  displayItem,
  sneakersDefect,
  sneakerDefectsCondition,
  printError,
} from '../../../utils/Helpers';
import {
  MANDIRI_CREDIT_CARD,
  MANDIRI_DEBIT_CARD,
  CREDITCARD,
  INSTALLMENTS,
  BCA_INSTALLMENTS,
  BANKTRANSFER,
  MANDIRI_VA,
  BCA_VA,
  PERMATA_VA,
  BNI_VA,
  BRI_VA,
  VIRTUALACCOUNT,
  FULLWALLET,
  BCA_CREDIT_CARD,
  BNI_CREDIT_CARD,
  BNI_DEBIT_CARD,
  BCA_KLIK_PAY,
  BCA_ONEKLIK,
  AKULAKU,
  ATOME,
  GOPAY,
  KREDIVO,
  getAdmFees,
  DEFAULT_PAYMENT_METHOD,
} from '../../../constants/paymentMethods';
import { isNumeric } from '../../../helpers/regex';
import { OFFER_GAP, VALIDATE_AMOUNT_DELAY } from '../../../config';
import ModalAddressBookV3 from '../../Modals/ModalAddressBookV3';
import ModalUpdatePaymentOfferV3 from '../../Modals/ModalUpdatePaymentOfferV3';
import { ModalOtp } from '../../Modals';
// ====== end of project component import section ====== //

// ========= action import section ========= //
import {
  getHistoryShipping,
  doPostShippingCost,
  doFetchProvinces,
} from '../../../actions/postalCodeAction';
import { deleteOffer, updateOffer } from '../../../actions/offerAction';
import {
  getOtp,
  resetOtpState,
  getOtpStatus,
} from '../../../actions/authAction';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import DataOfferInterface, {
  MaxAmountStateInterface,
} from '../../../interface/reducers/offer';
import { ShippingInterface } from '../../../interface/shipping';
import DataPostalCodeInterface, {
  CourierStateInterface,
} from '../../../interface/reducers/postalCode';
import AuthInterface from '../../../interface/reducers/auth';
import { ModalAlert } from '../../Modals';
import { useOutsideAlerter, useOtpStorage } from '../../../helpers/dom';
// ====== end of interface import section ====== //

const handlePaymentMethodText = (item: string) => {
  let firstText = '';
  let secondtext = '';

  switch (item) {
    case MANDIRI_CREDIT_CARD:
      firstText = 'MANDIRI Credit Card';
      secondtext = '';
      break;
    case MANDIRI_DEBIT_CARD:
      firstText = 'MANDIRI Debit Card';
      secondtext = '';
      break;
    case CREDITCARD:
    case INSTALLMENTS:
      firstText = '';
      secondtext = 'Credit / Debit Card / Installments';
      break;
    case BCA_INSTALLMENTS:
      firstText = 'BCA Installments';
      secondtext = '';
      break;
    case BANKTRANSFER:
      firstText = 'Bank Transfer';
      secondtext = '';
      break;
    case MANDIRI_VA:
      firstText = 'MANDIRI';
      secondtext = 'Virtual Account';
      break;
    case BCA_VA:
      firstText = 'BCA';
      secondtext = 'Virtual Account';
      break;
    case PERMATA_VA:
      firstText = 'PERMATA';
      secondtext = 'Virtual Account';
      break;
    case BNI_VA:
      firstText = 'BNI';
      secondtext = 'Virtual Account';
      break;
    case BRI_VA:
      firstText = 'BRI';
      secondtext = 'Virtual Account';
      break;
    case GOPAY:
      firstText = 'GOPAY';
      secondtext = '';
      break;
    case VIRTUALACCOUNT:
      firstText = 'Other Virtual Account';
      secondtext = '';
      break;
    case FULLWALLET:
      firstText = 'Kick Credit';
      secondtext = '';
      break;
    case BCA_CREDIT_CARD:
      firstText = 'BCA Credit Card / Debit Card';
      secondtext = '';
      break;
    case BNI_CREDIT_CARD:
      firstText = 'BNI Credit Card';
      secondtext = '';
      break;
    case BNI_DEBIT_CARD:
      firstText = 'BNI Debit Card';
      secondtext = '';
      break;
    case KREDIVO:
      firstText = 'Kredivo';
      secondtext = '';
      break;
    case ATOME:
      firstText = 'Atome';
      secondtext = '';
      break;
    case AKULAKU:
      firstText = 'Akulaku';
      secondtext = '';
      break;
    case BCA_KLIK_PAY:
      firstText = 'BCA';
      secondtext = 'Klik Play';
      break;
    case BCA_ONEKLIK:
      firstText = 'BCA';
      secondtext = 'One Klik';
      break;
    default:
      firstText = '';
      secondtext = '';
      break;
  }
  return secondtext + ' ' + firstText;
};

const fixingAmount = (value: any | number) => {
  if (isNumeric(value)) {
    let parsed = parseFloat(value);
    parsed -= value % OFFER_GAP;
    const summary = parsed + OFFER_GAP;
    const multipleGAP = value % OFFER_GAP;

    return parsed < OFFER_GAP
      ? OFFER_GAP
      : multipleGAP === 0
      ? parsed
      : summary;
  }
  return value;
};

interface GetShippingFeeInterface {
  country: string;
  destination?: number | null;
  origin?: number;
  weight: number;
  courier: string;
  product_variant_id: number;
  product_price: number;
}

type stateToProps = {
  dataOffer: DataOfferInterface;
  dataPostalCode: DataPostalCodeInterface;
  dataAuth: AuthInterface;
};

interface ModalOffer extends stateToProps {
  isOpen: boolean;
  ratio: number;
  couriers: CourierStateInterface;
  maxAmount: MaxAmountStateInterface;
  currency: string;
  onToggle: () => any;
  doFetchHistoryShipping: () => any;
  doFetchShippingFee: (args: GetShippingFeeInterface) => any;
  doFetchProvinces: (country: string) => any;
  doUpdateOffer: (...args: any) => any;
  callbackAfterUpdate: (...args: any) => any;
  doDeleteOffer: (bidId: number) => any;
}

/**
 * Modal for Buying Offer Detail on User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {ModalOffer} props for this component.
 * @return {JSX.Element}
 */
function ModalOfferComponent({
  isOpen,
  onToggle,
  dataOffer,
  dataPostalCode,
  doFetchHistoryShipping,
  doFetchShippingFee,
  doFetchProvinces,
  ratio,
  currency,
  couriers,
  maxAmount,
  doUpdateOffer,
  callbackAfterUpdate,
  doDeleteOffer,
  userData,
  otpCode,
  getOtp,
  resetOtpState,
  getOtpStatus,
  otpStatus,
}: ModalOffer): JSX.Element {
  const [isOtpActive, setIsOtpActive] = useState(false);
  // ============== Start of alerter helper for click outside wrapperRef div ==============
  const wrapperRef = useRef(null);
  const {
    saveToLocalStorage,
    checkIfExpired,
    resendOtp,
    resetOtpFromLocalstorage,
  } = useOtpStorage();
  useOutsideAlerter(wrapperRef, () => setOfferExpiryVisibility(false));
  // ============== End of alerter helper for click outside wrapperRef div ==============

  // ============== Start of updated current offer state data ==============
  const [currentAmount, setCurrentAmount] = useState<number>(0);
  const [currentShipping, setCurrentShipping] = useState<
    ShippingInterface | undefined
  >(undefined);
  const [tempCurrentShipping, setTempCurrentShipping] = useState<
    ShippingInterface | undefined
  >(undefined);
  const [currentPayment, setCurrentPayment] = useState<any>({});
  const [currentPaymentMethod, setCurrentPaymentMethod] = useState<string>('');
  const [paymentLabel, setPaymentLabel] = useState<string | null>('');
  const [currentOfferExpiryNumber, setCurrentOfferExpiryNumber] = useState<
    number | null
  >(null);
  const [offerExpiryVisibility, setOfferExpiryVisibility] = useState<boolean>(
    false,
  );
  const [currentOfferExpiry, setCurrentOfferExpiry] = useState<string>('');
  const [isUpdatedAddress, setUpdatedAddress] = useState<any>(null);
  const [isUseKickPoints, setUseKickPoints] = useState(false);
  const [currentMaxAmount, setCurrentMaxAmount] = useState('');
  const [error, setError] = useState<any>({});
  const [errorSubmit, setErrorSubmit] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitDeleting, setSubmitDeleting] = useState(false);
  const [_openModalWarning, set_openModalWarning] = useState(false);
  const [isBcaCard, setIsBcaCard] = useState(false);
  const [openModalWarningShipping, setOpenModalWarningShipping] = useState(
    false,
  );

  const [showModalOtp, setShowModalOtp] = useState(false);
  const [gettingOtp, setGettingOtp] = useState(false);
  const [otpErrorMsg, setOtpErrorMsg] = useState('');
  const [currentProcess, setCurrentProcess] = useState('');

  // ============== End of updated current offer state data ==============

  useEffect(() => {
    let errorTxt = '';
    let isError = false;
    if (currentAmount === 0 || !currentAmount) {
      isError = true;
      errorTxt = 'Please fill in the amount of your offer.';
    } else if (!isNumeric(currentAmount)) {
      isError = true;
      errorTxt = 'This field must be numeric.';
    } else if (maxAmount.data) {
      if (currentAmount === parseInt(currentMaxAmount)) {
        isError = true;
        errorTxt = `Cannot make an offer with the same price ${currency} ${formatRupiah(
          parseInt(currentMaxAmount) * ratio,
        )}. You should buy now!`;
      } else if (currentAmount > parseInt(currentMaxAmount)) {
        isError = true;
        errorTxt = `Cannot make an offer greater than ${currency} ${formatRupiah(
          parseInt(currentMaxAmount) * ratio,
        )}. You should buy now!`;
      }
    }
    setError({
      ...error,
      offerAmount: { isError, text: errorTxt },
    });
  }, [currentAmount]);

  // ============== Start of amount text input method helper ==============
  const [intervalKeyDown, setIntervalKeyDown] = useState(undefined);
  const onFixingAmount = (val: number) => {
    setCurrentAmount(fixingAmount(val));
  };
  const onChangeOfferAmount = (e: any) => {
    let dataBidAmount = currentAmount;
    switch (e.target.name) {
      case 'offerAmount':
        dataBidAmount = parseInt(
          e.target.value
            ? `${e.target.value.replace(/[\. ,:-]+/g, '')}.00`
            : '0.00',
        );
        break;
      default:
        return null;
    }
    setCurrentAmount(dataBidAmount);
    if (intervalKeyDown) clearTimeout(intervalKeyDown);
    const newIntervalKeyUp = setTimeout(() => {
      onFixingAmount(dataBidAmount);
      setIntervalKeyDown(undefined);
    }, VALIDATE_AMOUNT_DELAY);
    setIntervalKeyDown(newIntervalKeyUp);
  };

  const onBlur = () => {
    if (intervalKeyDown) clearTimeout(intervalKeyDown);
    setIntervalKeyDown(undefined);
    onFixingAmount(currentAmount);
  };
  // ============== End of amount text input method helper ==============

  // ============== Start of state for address book modal ==============
  const [shippingId, setShippingId] = useState<number | null>(null);
  const [defaultId, setDefaultId] = useState<number | null>(0);
  const [currentShippingPrice, setCurrentShippingPrice] = useState(0);
  const [isAddressButtonDisable, setIsAddressButtonDisable] = useState(false);
  const [isOpenedAddressBookModal, setOpenedAddressBookModal] = useState(false);
  const toggleAddressBookModal = () => {
    setOpenedAddressBookModal(!isOpenedAddressBookModal);
  };
  const changeId = (id: number) => {
    setIsAddressButtonDisable(true);
    setShippingId(id);
  };
  const submitShipping = async (id: number) => {
    setIsAddressButtonDisable(false);
    setDefaultId(shippingId);
    const temp = dataPostalCode.shippingHistory.data.filter(
      (item) => item.id === shippingId,
    )[0];

    if (temp.country !== 'IDN') {
      setOpenModalWarningShipping(true);
      setTempCurrentShipping(temp);
    } else {
      setCurrentShipping(temp);
      setShippingId(temp.id);
    }
    toggleAddressBookModal();

    const provinceId = dataPostalCode.provinces.data.filter(
      (prov) => prov.name === temp.province,
    );
    const weight = data.product_variant && data.product_variant.weight;
    const productVariantId = data.product_variant && data.product_variant.id;

    doFetchShippingFee({
      country: temp.country,
      destination: provinceId[0]?.id || null,
      weight: weight || 1000,
      product_variant_id: productVariantId,
      courier: 'FLAT_RATE',
      product_price: data.amount,
    }).then((res: any) => {
      setCurrentShippingPrice(res.value.data);
      setUpdatedAddress({
        id: temp.id,
        ka_courier: data.ka_courier,
        ka_courier_option: 'FLAT_RATE',
        ka_courier_price: res.value.data || data.ka_courier_price,
      });
    });
  };
  // ============== End of state for address book modal ==============

  // ============== Start of state for payment method modal ==============
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [administrationFee, setAdministrationFee] = useState<any>(null);
  const [discount, setDiscount] = useState<any>(null);
  const [isSelectPaymentFlagging, setIsSelectPaymentFlagging] = useState(false);

  const _handlePaymentTypeChange = (value: string) => {
    const _administrationFee = getAdmFees(
      value,
      parseFloat((data.amount / ratio).toString()),
      couriers.cost || 0,
      discount,
    );

    setAdministrationFee(_administrationFee);
  };
  const setPayment = (val: typeof DEFAULT_PAYMENT_METHOD[0]) => {
    setIsBcaCard(val.label === 'BCA Card');
    setCurrentPayment(val);
    setCurrentPaymentMethod(val.payment_method);
    _handlePaymentTypeChange(val.payment_method);
  };
  // ============== End of state for payment method modal ==============

  const _modalWarningToggle = () => {
    set_openModalWarning(!_openModalWarning);
  };

  const _modalWarningShipping = () => {
    setOpenModalWarningShipping(!openModalWarningShipping);
    if (currentShipping?.id && shippingId !== currentShipping.id) {
      setShippingId(currentShipping.id);
      setTempCurrentShipping(undefined);
    }
  };

  const { data } = dataOffer.offerDetails;
  useEffect(() => {
    if (data) {
      let selectedPayment = DEFAULT_PAYMENT_METHOD.find(
        (item) =>
          item.payment_method === data.payment_type &&
          item.label !== 'BCA Card',
      );
      if (data.payment_via === 'spa' && data.payment_type === 'credit_card') {
        setIsBcaCard(true);
        selectedPayment = DEFAULT_PAYMENT_METHOD.find(
          (item) => item.label === 'BCA Card',
        );
      } else {
        setIsBcaCard(false);
      }
      if (selectedPayment) {
        setPaymentLabel(selectedPayment?.label);
        setCurrentPayment(selectedPayment);
      }

      setErrorSubmit('');
      setCurrentAmount(data.amount);
      setCurrentShipping(data.shipping);
      setCurrentPaymentMethod(data.payment_type);
      setCurrentOfferExpiry(data.expired_at);
      doFetchHistoryShipping();
    }
    doFetchProvinces('IDN');
  }, [data]);

  useEffect(() => {
    if (data) {
      setDefaultId(data.shipping.id);
      setShippingId(data.shipping.id);
      setCurrentShippingPrice(data.ka_courier_price);
      setIsBcaCard(
        data?.payment_via === 'spa' && data?.payment_type === 'credit_card',
      );
    }
  }, [dataPostalCode.shippingHistory]);

  useEffect(() => {
    if (maxAmount.data) {
      setCurrentMaxAmount(parseInt(maxAmount.data.max_amount));
    }
  }, [maxAmount]);

  const getOtpHandler = () => {
    if (checkIfExpired()) {
      getOtp();
    } else {
      setShowModalOtp(true);
      setGettingOtp(false);
      setOtpErrorMsg('');
    }
  };

  useEffect(() => {
    if (otpStatus?.data?.pay_with_wallet) {
      setIsOtpActive(otpStatus.data.pay_with_wallet);
    } else {
      setIsOtpActive(false);
    }
  }, [otpStatus?.data?.pay_with_wallet]);

  useEffect(() => {
    if (otpCode.success) {
      setOtpErrorMsg('');
      setGettingOtp(false);
      setShowModalOtp(true);
      saveToLocalStorage();
    } else if (otpCode?.message) {
      setOtpErrorMsg(otpCode?.message);
      setGettingOtp(false);
      setShowModalOtp(true);
    } else {
      setOtpErrorMsg('');
    }
  }, [otpCode]);

  useEffect(() => {
    getOtpStatus();
  }, []);

  // If data is available, then show the modal
  if (data && !dataOffer.offerDetails.isFetch) {
    const isDefects = data?.user_sell?.defects?.length > 0;
    const isSameAsBefore =
      currentAmount === data.amount &&
      currentShipping === data.shipping &&
      currentPaymentMethod === data.payment_type &&
      paymentLabel === currentPayment.label &&
      currentOfferExpiry === data.expired_at &&
      currentOfferExpiryNumber === null;
    const imageUrl = data.product_variant.product_variant_images.length
      ? data.product_variant.product_variant_images[0].URL
      : null;
    const category = data.product_variant.product.category.name;
    const uniqueDefects = _.uniqBy(
      isDefects ? data.user_sell.defects : [],
      'name',
    );
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a) => a.name === 'DUST_BAG')
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a) => a.name === 'BOX')
      : {};
    const sneakersDetailArr = [
      sneakersCondition(data.sneakers_condition),
      boxCondition(data.box_condition),
      accessoriesCondition(data.missing_accessories),
      yellowing(data.yellowing),
      displayItem(data.display_item),
      sneakersDefect(data.sneakers_defect),
      isDefects ? sneakerDefectsCondition(uniqueDefects) : '',
    ];
    const sneakersDetail = sneakersDetailArr
      .filter((item) => item !== '')
      .map((items) => items)
      .join(' / ');
    const hasError =
      Object.keys(error)
        .map((t) => error[t].isError)
        .filter((i) => i).length > 0;

    const onSave = (otpCode) => {
      if (isSameAsBefore || hasError || submitting || errorSubmit !== '') {
        return;
      }
      const payload: any = {
        amount: currentAmount,
        expiry: currentOfferExpiryNumber,
        payment_method: currentPaymentMethod,
        shipping_id: isUpdatedAddress && isUpdatedAddress.id,
        ka_courier: isUpdatedAddress && isUpdatedAddress.ka_courier,
        ka_courier_option:
          isUpdatedAddress && isUpdatedAddress.ka_courier_option,
        ka_courier_price: isUpdatedAddress && isUpdatedAddress.ka_courier_price,
        administration_fee: 0,
        point_enabled: isUseKickPoints,
      };
      if (otpCode) {
        payload.otp = otpCode;
      }
      const shippingCountry = currentShipping?.country || 'IDN';

      if (
        currentPayment.payment_method === 'credit_card' ||
        currentPayment.payment_method === BCA_CREDIT_CARD
      ) {
        if (
          currentPayment.label === 'BCA Card' ||
          currentPayment.payment_method === BCA_CREDIT_CARD
        ) {
          payload.payment_via = 'spa';
        } else if (shippingCountry !== 'IDN') {
          payload.payment_via = 'xnd';
        } else {
          payload.payment_via = 'vt';
        }
      }

      if (!currentOfferExpiryNumber) delete payload.expiry;
      if (
        currentPaymentMethod === data.payment_type &&
        currentPayment.label === paymentLabel
      ) {
        payload.administration_fee = data.administration_fee;
      }
      if (!isUpdatedAddress) {
        delete payload.shipping_id;
        delete payload.ka_courier;
        delete payload.ka_courier_option;
        delete payload.ka_courier_price;
      }

      setSubmitting(true);
      doUpdateOffer(data.id, payload)
        .then(() => {
          callbackAfterUpdate();
          onToggle();
          setSubmitting(false);
          resetOtpFromLocalstorage();
          setShowModalOtp(false);
        })
        .catch((e: any) => {
          setSubmitting(false);
          const printErrorMsg = printError(error);
          setErrorSubmit(
            printErrorMsg === 'Invalid OTP'
              ? ('' as string)
              : (printErrorMsg as string),
          );
          setOtpErrorMsg(printErrorMsg === 'Invalid OTP' ? printErrorMsg : '');
          if (currentPaymentMethod === 'full_wallet' && isOtpActive) {
            setGettingOtp(false);
            setShowModalOtp(true);
          }
        });
    };

    const onDelete = () => {
      if (!submitDeleting) set_openModalWarning(true);
    };

    const onSubmitDelete = () => {
      doDeleteOffer(data.id).then(() => {
        callbackAfterUpdate();
        onToggle();
        setSubmitDeleting(false);
      });
    };

    const onSubmitChangeShipping = () => {
      if (tempCurrentShipping) {
        setCurrentShipping(tempCurrentShipping);
        setShippingId(tempCurrentShipping?.id || null);
        setTempCurrentShipping(undefined);
      }
      setOpenModalWarningShipping(false);
    };

    const LuxuryArr = [
      sneakersCondition(data.sneakers_condition),
      accessoriesCondition(data.missing_accessories),
      dustBagCondition?.value ? null : dustBag(dustBagCondition),
      boxConditions?.value ? null : boxHandbag(boxConditions),
      isDefects ? handbagCondition(uniqueDefects) : '',
    ];
    const LuxuryDetails = LuxuryArr.filter((item) => item !== '')
      .map((items) => items)
      .join(' / ');

    const isTicket = data?.product_variant?.product?.name.includes('Ticket');

    return (
      <Modal
        className="offer-detail-modal"
        toggle={onToggle}
        isOpen={isOpen}
        centered
      >
        <>
          <div className={'content-modal'}>
            <div className={'header-section'}>
              <div className={'left'}>
                <p className={'product-title'}>
                  {data.product_variant.display_name}
                </p>
                <p className={'product-sku'}>{data.product_variant.SKU}</p>
              </div>
              <div className={'right'}>
                <div>
                  {category === 'handbags' ||
                  (category === 'lifestyles' &&
                    data.size.US.toLowerCase() !== 'all size') ? (
                    <div className={'size-container'}>
                      <p>{data.size.US}</p>
                    </div>
                  ) : (
                    <div className={'size-container'}>
                      <p>US {data.size.US}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={'image-section'}>
              <KickImage
                src={
                  imageUrl
                    ? getCloudImageUrl(imageUrl, 300)
                    : emptyImage(category)
                }
              />
            </div>
            <div className={'product-condition-section'}>
              <p className={'title'}>Product Conditions</p>
              {
                isTicket ?
                <p className={'value'}>{sneakersCondition(data.sneakers_condition)}</p> : 
                <p className={'value'}>
                  {data.product_variant.vintage
                    ? 'Vintage'
                    : category === 'handbags'
                    ? LuxuryDetails
                    : sneakersDetail}
                </p>
              }
            </div>
            <div className={'price-section'}>
              <div className={'lowest'}>
                <p className={'title'}>Lowest Price</p>
                <p className={'value'}>IDR {formatRupiah(data.lowest_ask)}</p>
              </div>
              <div className={'highest'}>
                <p className={'title'}>Highest Offer</p>
                <p className={'value'}>
                  IDR{' '}
                  {formatRupiah(data.highest_bid ? data.highest_bid.amount : 0)}
                </p>
              </div>
            </div>
            <div className={'offer-detail-section'}>
              <p className={'title'}>Offer Details</p>
              <div className={'date-container'}>
                <div className={'date-form-container'}>
                  <p className={'title'}>Offer Date</p>
                  <div className={'date-form-disabled'}>
                    <p>{moment(data.created_at).format('MMMM DD, YYYY')}</p>
                  </div>
                </div>
                <div className={'date-form-container'}>
                  <p className={'title'}>Offer Expiry</p>
                  <div
                    className={'date-form'}
                    onClick={() =>
                      setOfferExpiryVisibility(!offerExpiryVisibility)
                    }
                  >
                    <p>{moment(currentOfferExpiry).format('MMMM DD, YYYY')}</p>
                    <IconContext.Provider
                      value={{ color: '#242424', size: '10px' }}
                    >
                      <div>
                        <GrFormDown />
                      </div>
                    </IconContext.Provider>
                  </div>
                </div>
                {offerExpiryVisibility && (
                  <div
                    className={'expiry-date-choice-container'}
                    ref={wrapperRef}
                  >
                    <div
                      className={'expiry-date-choice'}
                      onClick={() => {
                        setCurrentOfferExpiry(
                          moment(data.expired_at)
                            .add(7, 'days')
                            .toISOString(),
                        );
                        setCurrentOfferExpiryNumber(7);
                        setOfferExpiryVisibility(false);
                      }}
                    >
                      Extend 7 days
                    </div>
                    <div
                      className={'expiry-date-choice'}
                      onClick={() => {
                        setCurrentOfferExpiry(
                          moment(data.expired_at)
                            .add(14, 'days')
                            .toISOString(),
                        );
                        setCurrentOfferExpiryNumber(14);
                        setOfferExpiryVisibility(false);
                      }}
                    >
                      Extend 14 days
                    </div>
                    <div
                      className={'expiry-date-choice'}
                      onClick={() => {
                        setCurrentOfferExpiry(
                          moment(data.expired_at)
                            .add(30, 'days')
                            .toISOString(),
                        );
                        setCurrentOfferExpiryNumber(30);
                        setOfferExpiryVisibility(false);
                      }}
                    >
                      Extend 30 days
                    </div>
                  </div>
                )}
              </div>
              <div className={'form-container'}>
                <p className={'title'}>Shipping Address</p>
                <div className={'child-form'} onClick={toggleAddressBookModal}>
                  <p>
                    {currentShipping && currentShipping.alias} -{' '}
                    {currentShipping && currentShipping.full_name}
                  </p>
                  <IconContext.Provider
                    value={{ color: '#242424', size: '10px' }}
                  >
                    <div>
                      <GrFormDown />
                    </div>
                  </IconContext.Provider>
                </div>
              </div>
              <div className={'form-container'}>
                <p className={'title'}>Payment Method</p>
                <div
                  className={'child-form'}
                  onClick={() => setOpenPaymentModal(!openPaymentModal)}
                >
                  <p>
                    {isBcaCard
                      ? 'BCA Card'
                      : handlePaymentMethodText(currentPaymentMethod)}
                  </p>
                  <IconContext.Provider
                    value={{ color: '#242424', size: '10px' }}
                  >
                    <div>
                      <GrFormDown />
                    </div>
                  </IconContext.Provider>
                </div>
              </div>
              <div className={'form-container'}>
                <p className={'title'}>Offer Price</p>
                <div className={'child-form-input'}>
                  <p>IDR </p>
                  <CurrencyFormat
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    value={currentAmount}
                    name={'offerAmount'}
                    onChange={onChangeOfferAmount}
                    onBlur={onBlur}
                    // disabled={disabledInput(props._outOfStock)}
                  />
                </div>
                {error['offerAmount'] && error['offerAmount'].isError && (
                  <p className={'error-txt'}>{error['offerAmount'].text}</p>
                )}
                {errorSubmit !== '' && (
                  <p className={'error-txt'}>{errorSubmit}</p>
                )}
              </div>
              <div
                className={
                  isSameAsBefore || hasError || submitting || errorSubmit !== ''
                    ? 'button-submit-disabled'
                    : 'button-submit'
                }
                onClick={() => {
                  if (currentPaymentMethod === 'full_wallet' && isOtpActive) {
                    getOtpHandler();
                  } else {
                    onSave();
                  }
                }}
              >
                {submitting ? 'Updating your offer...' : 'Save'}
              </div>
            </div>
            <div className={'button-delete'} onClick={onDelete}>
              {submitDeleting ? 'Deleting your Offer...' : 'Delete Offer'}
            </div>
          </div>
          <ModalAddressBookV3
            isOpen={isOpenedAddressBookModal}
            onToggle={toggleAddressBookModal}
            dataAddress={dataPostalCode.shippingHistory.data}
            countries={dataPostalCode.countries.data}
            provinces={dataPostalCode.provinces.data}
            cities={dataPostalCode.cities.data}
            id={shippingId}
            changeId={changeId}
            defaultId={defaultId}
            submitShipping={submitShipping}
            getHistoryShipping={doFetchHistoryShipping}
            isModalOffer={true}
            isAddressButtonDisable={isAddressButtonDisable}
            modalTitle={'Change Address'}
          />
          <ModalUpdatePaymentOfferV3
            isModalOpen={openPaymentModal}
            currentPayment={currentPayment}
            onToggle={() => setOpenPaymentModal(!openPaymentModal)}
            handleCurrentPaymentType={(item: any, enabledKickPoint: any) => {
              if (item) {
                setPayment(item);
              }
              setUseKickPoints(enabledKickPoint);
            }}
            currentOfferData={data.amount}
            isSelectPaymentFlagging={() => {
              setIsSelectPaymentFlagging(true);
            }}
            currentShippingPrice={currentShippingPrice}
            currentShippingCountry={currentShipping?.country || 'IDN'}
          />
          <ModalAlert
            isOpen={_openModalWarning}
            onToggle={_modalWarningToggle}
            title="Delete Offer"
            contentText="Are you sure you want to delete your offer?"
            showButton
            onSubmit={onSubmitDelete}
          />
          <ModalAlert
            isOpen={openModalWarningShipping}
            onToggle={_modalWarningShipping}
            title="Update shipping address"
            contentText="The payment method will automatically be changed to International Credit Card if you change your shipping address to other countries. Are you sure?"
            showButton
            onSubmit={onSubmitChangeShipping}
          />
          <div className={'close-button'} onClick={onToggle}>
            <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
              <div>
                <GrClose />
              </div>
            </IconContext.Provider>
          </div>
          <Modal
            toggle={() => {
              setShowModalOtp(false);
              resetOtpState();
            }}
            isOpen={showModalOtp}
            className="modal-otp-wrapper"
          >
            <ModalOtp
              show={showModalOtp}
              onHide={() => {
                setShowModalOtp(false);
                resetOtpState();
              }}
              email={userData?.email ?? ''}
              submitOtp={(otpCode) => {
                // setShowModalOtp(false)
                onSave(otpCode);
              }}
              resendCode={() => {
                // getOtpHandler()
                getOtp();
                setGettingOtp(true);
                resendOtp();
              }}
              gettingOtp={gettingOtp}
              errorMsg={otpErrorMsg}
              currentProcess={currentProcess}
              backAction={() => {
                setShowModalOtp(false);
                resetOtpState();
              }}
            />
          </Modal>
        </>
      </Modal>
    );
  }
  // Not rendering the modal component is data is unavailable to prevent undefined error
  return <div />;
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataOffer: state.dataOffer,
    dataPostalCode: state.dataPostalCode,
    couriers: state.dataPostalCode.couriers,
    maxAmount: state.dataOffer.maxAmount,
    currency: state.dataAuth.userCurrency.currency,
    ratio: state.dataAuth.userCurrency.ratio,
    otpCode: state.dataAuth.otpCode,
    otpStatus: state.dataAuth.otpStatus,
    userData: state.dataAuth.userdata,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doFetchHistoryShipping: () => dispatch(getHistoryShipping()),
    doFetchShippingFee: ({
      country,
      destination,
      origin = 153,
      weight = 1000,
      courier = 'FLAT_RATE',
      product_variant_id,
      product_price,
    }: GetShippingFeeInterface) =>
      dispatch(
        doPostShippingCost({
          country,
          destination,
          origin,
          weight,
          courier,
          product_variant_id,
          product_price,
        }),
      ),
    doUpdateOffer: (bidId: number, payload: any) =>
      dispatch(updateOffer(bidId, payload)),
    doDeleteOffer: (bidId: number) => dispatch(deleteOffer(bidId)),
    doFetchProvinces: (country: string) => dispatch(doFetchProvinces(country)),
    getOtp: () => dispatch(getOtp()),
    getOtpStatus: () => dispatch(getOtpStatus()),
    resetOtpState: () => dispatch(resetOtpState()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalOfferComponent);
